import {
    getFlexibleLifeFondsDaten20,
    getFlexibleLifeFondsDaten,
    getVollwertFondsDaten,
} from "../../api/fonds";
import store from "@/store";

const getDefaultState = () => {
    return {
        flexiblelife: {},
        vollwert: {},
    };
};

const state = getDefaultState();

const getters = {};

const actions = {
    getFlexibleLifeFondsDaten20({ commit, state }) {
        if (Object.keys(state.flexiblelife).length === 0) {
            commit("setLoading", true, { root: true });
        }
        getFlexibleLifeFondsDaten20()
            .then((response) => {
                if (response.data.Status === 200) {
                    commit("setFlexibleLifeFonds", response.data.Result);
                } else {
                    store.cache.delete("fonds/getFlexibleLifeFondsDaten20");
                }
            })
            .catch(() => {
                store.cache.delete("fonds/getFlexibleLifeFondsDaten20");
            });
    },
    getFlexibleLifeFondsDaten({ commit, state }) {
        if (Object.keys(state.flexiblelife).length === 0) {
            commit("setLoading", true, { root: true });
        }
        getFlexibleLifeFondsDaten()
            .then((response) => {
                if (response.data.Status === 200) {
                    commit("setFlexibleLifeFonds", response.data.Result);
                } else {
                    store.cache.delete("fonds/getFlexibleLifeFondsDaten");
                }
            })
            .catch(() => {
                store.cache.delete("fonds/getFlexibleLifeFondsDaten");
            });
    },
    getVollwertFondsDaten({ commit, state }) {
        if (Object.keys(state.vollwert).length === 0) {
            commit("setLoading", true, { root: true });
        }
        getVollwertFondsDaten()
            .then((response) => {
                if (response.data.Status === 200) {
                    commit("setVollwertFonds", response.data.Result);
                } else {
                    store.cache.delete("fonds/getVollwertFondsDaten");
                }
            })
            .catch(() => {
                store.cache.delete("fonds/getVollwertFondsDaten");
            });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setFlexibleLifeFonds(state, fonds) {
        state.flexiblelife = fonds;
    },
    setVollwertFonds(state, fonds) {
        state.vollwert = fonds;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
